var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocalPoliceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 12.4963L15.13 15.2262C15.23 15.6562 14.76 15.9962 14.38 15.7662L12 14.3263L9.61 15.7662C9.23 15.9962 8.76 15.6562 8.86 15.2262L9.5 12.5063L7.4 10.6962C7.06 10.4062 7.24 9.85625 7.68 9.81625L10.46 9.57625L11.54 7.01625C11.71 6.60625 12.29 6.60625 12.46 7.01625L13.54 9.56625L16.32 9.80625C16.76 9.84625 16.94 10.3962 16.6 10.6862L14.5 12.4963ZM4.19 4.37625C3.47 4.69625 3 5.41625 3 6.20625V10.9062C3 16.4563 6.84 21.6462 12 22.9062C17.16 21.6462 21 16.4563 21 10.9062V6.20625C21 5.41625 20.53 4.69625 19.81 4.37625L12.81 1.26625C12.29 1.03625 11.7 1.03625 11.19 1.26625L4.19 4.37625Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalPoliceIcon);
export default __webpack_public_path__ + "static/media/LocalPoliceIcon.a96a9bfd8ee85d7c7a2918df214e8504.svg";
export { ForwardRef as ReactComponent };